import { createFileRoute, redirect } from "@tanstack/react-router";
import AdminLayout from "@/components/admin/AdminLayout";

export const Route = createFileRoute("/_adminLayout")({
  // Sign-in state only exists in the browser, so never server-render the
  // admin shell — decide first, then load.
  ssr: false,
  beforeLoad: async () => {
    const { supabase } = await import("@/integrations/supabase/client");
    const session = await Promise.race([
      supabase.auth.getSession().then(({ data }) => data.session ?? null),
      new Promise<null>((resolve) => setTimeout(() => resolve(null), 3000)),
    ]).catch(() => null);

    // Reject expired sessions so a stale token doesn't reach protected server
    // functions and surface as an Unauthorized crash inside the admin UI.
    const expired =
      !!session &&
      typeof session.expires_at === "number" &&
      session.expires_at * 1000 <= Date.now();

    if (!session || expired) throw redirect({ to: "/admin/login" });
  },
  component: () => <AdminLayout />,
});

